"use strict";

$(document).ready(function () {
  var page;
  var templateId = $('body').data('template');
  /*
   * Init Nette JS
   */

  naja.initialize();
  var form = new FormComponent();
  var flashMessage = new FlashMessage();
  /*
  * Init page controller by template
  */

  switch (templateId) {
    case "sign-in":
      page = new SignController();
      break;

    case "reservation-create":
      page = new CreateEditReservationController();
      break;

    case "reservation-overview":
      page = new ReservationOverviewController();
      break;

    case "reservation-edit":
      page = new CreateEditReservationController();
      break;

    default:
      // init generic page controller for other templates
      page = new PageController();
      break;
  }

  this.body = document.getElementsByTagName("body")[0];
  this.header = document.getElementsByTagName("header")[0];
  this.footer = document.getElementsByTagName("footer");
  this.content = document.getElementById("content");
  this.footerLayout = new FooterComponent(this.header, this.footer, this.content);
});